export default "__VITE_ASSET__DZ0zObnh__"